import React, { useEffect, useState, useRef } from "react";
import TeachersArray from "../../../data/TeachersArray";
import TeacherCard from "./TeacherCard";
import seo_keywords from "../../../data/seo";

function SchoolTeachers() {
  const [fade, setFade] = useState(false);
  const [isListVisible, setIsListVisible] = useState(true);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const teacherCardRef = useRef();

  const handleClickReturn = () => {
    setFade(true);
    setTimeout(() => {
      setIsListVisible(true);
      setFade(false);
    }, 600);
  };

  const handleTeacherSelect = (teacher) => {
    setFade(true);
    setTimeout(() => {
      setSelectedTeacher(teacher.id);
      setIsListVisible(false);
      setFade(false);
    }, 600);
  };

  const selectedTeacherInfo = TeachersArray.find(
    (teacher) => teacher.id === selectedTeacher,
  );

  useEffect(() => {
    if (!isListVisible && teacherCardRef.current) {
      teacherCardRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isListVisible]);

  return (
    <div className="school-container mx-md-2 my-4 mx-3">
      <div className={`teacher-section-content ${fade ? "fade-out" : "fade-in"}`} ref={teacherCardRef}>
        { isListVisible ? (
          <>
            <div className="row py-3 px-4 p-sm-4 d-flex justify-content-around align-items-center">
              <div className="col-11">
                <div className="row d-flex flex-row align-items-center">
                  <span className="panel-title pl-sm-3 pl-xl-0 pr-3 pb-0">Poznaj nas</span>
                  <span className="pl-sm-3 pl-xl-0">Kliknij w profil aby dowiedzieć się więcej o nas</span>
                </div>
              </div>
              <div className="col-xl-0" />


            </div>
            <div className="teacher-grid">
              {TeachersArray.map(teacher => (
                <button
                  type="button"
                  key={teacher.id}
                  className="teacher-grid-profile"
                  onClick={() => handleTeacherSelect(teacher)}
                >
                  <img
                    src={teacher.imgURL}
                    alt={seo_keywords}
                    draggable="false"
                    className="portrait-image rounded-circle mx-auto d-block"
                  />
                  <div>
                    <p className="panel-title m-2 pb-2 text-center">{teacher.name}</p>
                  </div>
                </button>
              ))}
            </div>
          </>
        )
          : (
            <>
              <div className="p-3 py-5">
                <TeacherCard
                  id={selectedTeacherInfo.id}
                  name={selectedTeacherInfo.name}
                  imgURL={selectedTeacherInfo.imgURL}
                  aboutMeText={selectedTeacherInfo.aboutMeText}
                />
              </div>
              <button
                type="button"
                className="teacher-footer d-flex py-3"
                onClick={handleClickReturn}
                aria-label="Powrót do listy nauczycieli"
              >
                <i className="fas fa-undo-alt fa-lg" />
              </button>
            </>
          )}
      </div>
    </div>
  );
}

export default SchoolTeachers;
